export const DOCS_SRC_URL = 'https://github.com/unified-doc/docs/tree/main/src';
export const GITHUB_URL = 'https://www.github.com/unified-doc';
export const UNIFIED_URL = 'https://unifiedjs.com/';
